import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import styles from './NewsBox.module.scss';
import moment from 'moment';
import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';
import { ANCHOR } from 'common/consts/common';
import Link from 'common/components/LocalizedLink/LocalizedLink';

export default class NewsBox extends Component {
  static propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    url: PropTypes.string,
    category: PropTypes.string.isRequired
  };

  currentLanguage = LanguageService.getLang();

  render() {
    const { title, image, date, slug, category } = this.props;
    return (
      <div className={styles.Wrapper}>
        <Link to={`${ANCHOR.NEWS[this.currentLanguage]}/${category}/${slug}`}>
          <div
            className={styles.Image}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                image
              )})`
            }}
          />
        </Link>
        <Link to={`${ANCHOR.NEWS[this.currentLanguage]}/${category}/${slug}`}>
          <h4 className={styles.NewsTitle}>{title}</h4>
        </Link>
        <p className={styles.DateParagraph}>{moment(date).format('LL')}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/NewsAndEvents/Components/NewsBox/NewsBox.js